"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagTK = function FlagTK(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M188.35,104H-94.13a7.07,7.07,0,0,1-7.07-7.06,7.07,7.07,0,0,1,7.07-7.06H188.35l7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M191.88,82.8h-286S18.86-44.32,124.79-72.57c0,0-35.31,91.81,49.44,148.31h17.65a3.53,3.53,0,0,1,0,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-106.47,41.92l2.74,8.21,8.66.07a1.17,1.17,0,0,1,.68,2.11l-7,5.14,2.61,8.26a1.17,1.17,0,0,1-1.79,1.3l-7-5-7,5a1.16,1.16,0,0,1-1.78-1.3l2.61-8.26-7-5.14a1.17,1.17,0,0,1,.68-2.11l8.66-.07,2.75-8.21a1.17,1.17,0,0,1,2.21,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-106.68-71l2.22,6.66,7,.06a.94.94,0,0,1,.55,1.7l-5.65,4.18,2.12,6.7a.94.94,0,0,1-1.45,1.05l-5.72-4.08-5.72,4.08a.94.94,0,0,1-1.45-1.05l2.12-6.7-5.65-4.18a.94.94,0,0,1,.55-1.7l7-.06,2.22-6.66a1,1,0,0,1,1.8,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-159.91-29.8l2.22,6.67,7,.05a1,1,0,0,1,.55,1.71l-5.65,4.17,2.12,6.7a1,1,0,0,1-1.45,1.06l-5.72-4.09-5.72,4.09A1,1,0,0,1-168-10.5l2.12-6.7-5.65-4.17a1,1,0,0,1,.55-1.71l7-.05,2.22-6.67a1,1,0,0,1,1.8,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-68.61-32.61l1.71,5.13,5.41,0a.73.73,0,0,1,.43,1.32l-4.35,3.21,1.62,5.16a.72.72,0,0,1-1.11.81l-4.4-3.15-4.4,3.15a.73.73,0,0,1-1.12-.81l1.63-5.16-4.35-3.21a.73.73,0,0,1,.43-1.32l5.41,0L-70-32.61a.73.73,0,0,1,1.38,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagTK;
exports["default"] = _default;